import { ApiResponse, getData } from './Apis';

export type EmailAlreadyAppliedWarningModel = {
    Warning: string,
}

export async function API_GetEmailAlreadyAppliedWarning(): Promise<ApiResponse<EmailAlreadyAppliedWarningModel>> {
    return await getData<ApiResponse<EmailAlreadyAppliedWarningModel>>("webapi/candidate/system/EmailAlreadyAppliedWarning");
}
